import React, { useState, useEffect } from 'react';
import './HeroSlider.css';

const HeroSlider = ({ images, interval = 15000, zoom = 1.1 }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="hero-slider">
      <div className="hero-logo">
        <img src="/img/logo.png" alt="Le Hameau du Sorbier" />
      </div>

      {images.map((img, i) => (
        <div
          key={i}
          className={`hero-slide ${i === index ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}

      <div className="hero-text">
        <h1>Le Hameau du Sorbier</h1>
        <h3>Un séjour inoubliable dans un écrin de verdure</h3>
        <div className="scroll-indicator">↓</div>
      </div>
    </div>
  );
};

export default HeroSlider;
